import { useContext } from 'react';
import { EmoviDocContext } from '../EmoviDocProvider';

export function useEmoviDoc() {
  const context = useContext(EmoviDocContext);
  if (!context) {
    throw new Error('useEmoviDoc must be used within EmoviDocProvider');
  }

  return context;
}
